<template>
  <div class="usuarios">
    <v-card class="mt-3">
      <div class="pa-3" style="font-size: 16px">
        <div><strong>Código Usuário:</strong> {{ usuario.identificadorusuario }}</div>
        <div><strong>Nome:</strong> {{ usuario.nomeusuario }}</div>
        <div><strong>E-mail:</strong> {{ usuario.emailusuario }}</div>
      </div>
    </v-card>

    <div class="mt-2 mb-2 btn-acoes">
      <div class="btn-acoes-itens" style="text-align: right">
        <v-btn color="cyan" small dark :to="{ path: `/gerencial/vincular-perfil/${usuario.identificadorusuario}/perfil/novo`}" class="rounded-sm font-weight-regular" width="90px">Novo</v-btn>
      </div>
    </div>

    <v-alert type="error" v-if="usuarioPerfis.length <= 0" value="true" dark class="mt-3 mb-3">
      <div>Nenhum perfil de usuário cadastrado!</div>
    </v-alert>
    <v-card v-else style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>
            <th>Código</th>
            <th>Perfil</th>
            <th>SubPerfil</th>
            <th>Matrícula RH</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="perfil in usuarioPerfis" :key="perfil.identificadorusuarioperfil">
            <td class="centro">{{ perfil.identificadorusuarioperfil }}</td>
            <td class="centro">{{ perfil.nomeperfil }}</td>
            <td class="centro">{{ perfil.nomesubperfil || '-' }}</td>
            <td class="centro">{{ (perfil.cdpessoal && perfil.cdpessoal) ? `${perfil.cdpessoal} - ${perfil.cdmatric}` : '-' }}</td>
            <td class="centro">
                <v-tooltip bottom v-model="show">
                  <template v-slot:activator="{ on }" >
                     <span v-on="on">
                          <v-btn icon title=""
                          class="aulas-btn-acao"  light v-on="on"
                          :to="{ path: `/gerencial/vincular-perfil/${perfil.identificadorusuario}/perfil/${perfil.identificadorusuarioperfil}` }"
                          :disabled="desabilitarAcoes(perfil)">
                            <v-icon class="btn-acoes-icon">edit</v-icon>
                          </v-btn>
                    </span>
                  </template>
                   <span>{{desabilitarAcoes(perfil)? 'Você não tem autorização para editar esse perfil': 'Editar'}}</span>
                </v-tooltip>
                <v-tooltip bottom v-model="show">
                  <template v-slot:activator="{ on }" >
                     <span v-on="on">
                          <v-btn icon title="" light v-on="on"
                          @click="excluir(perfil.identificadorusuarioperfil)"
                          :disabled="desabilitarAcoes(perfil)">
                            <v-icon color="red">delete_forever</v-icon>
                          </v-btn>
                    </span>
                  </template>
                   <span>{{desabilitarAcoes(perfil)? 'Você não tem autorização para excluir esse perfil': 'Excluir'}}</span>
                </v-tooltip>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { mapGetters, mapState, mapMutations } from 'vuex';
import router from '../routes/gerencial';
import store from '@/store';

const AtenaUsuarioRepository = RepositoryFactory.get('atenaUsuario');
const VincularPerfilRepository = RepositoryFactory.get('vincularPerfil');

export default {
  name: 'VincularPerfil',
  props: {
   idUsuario: [Number, String],

  },
  data() {
    return {
      usuarioPerfis: [],
      usuario: {},
      snackbar: false,
      submitText: '',
      identificadorusuarioperfilatual: null,
    };
  },
  async beforeRouteEnter(to, from, next){

     const {perfilAtual} = store.getters.userDadosPerfilAtual;
     const { data } = await VincularPerfilRepository.getUsuarioPerfis(store.getters.userDadosPerfilAtual.identificadorusuario);
     next(vm => vm.reload(data));
  },

  computed: {
    ...mapGetters(['getAnoSistema',  'userDadosPerfilAtual', 'userProfessor', 'profiles'])

  },
  methods: {
    async teste () {
      const { data } = await VincularPerfilRepository.getUsuarioPerfis(store.getters.userDadosPerfilAtual.identificadorusuario);
      next(vm => vm.reload(data));
    },

    desabilitarAcoes(dados) {
      return (dados.identificadorusuarioperfil === this.identificadorusuarioperfilatual) ||
              (dados.indicadelecaoperfil === 'N') ? true : false;
    },

    async reload(data = null) {
      try {
        if(!data) {
          this.$Progress.start();
          const retorno = await VincularPerfilRepository.getUsuarioPerfis(store.getters.userDadosPerfilAtual.identificadorusuario);
          data = retorno.data;
        }
        this.usuarioPerfis = data.results.userPerfis;
        this.usuario = data.results.user;
        store.dispatch('atualizarperfis');
        this.identificadorusuarioperfilatual= store.getters.userDadosPerfilAtual.identificadorusuarioperfil;

      } finally {
        this.$Progress.finish();
      }
    },
    async excluir(id) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este perfil de usuário?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await VincularPerfilRepository.deleteUsuarioPerfil(this.usuario.identificadorusuario, id);

        this.submitText = data.message;
        this.snackbar = true;
        if(this.paginaAtual > 1 && this.telas.length == 1) { this.paginaAtual--; }
        this.reload();
      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
  },
}
</script>

<style lang="scss">
.usuarios {
  margin: 0px 15px;

  .btn-acoes {
    display: flex;
    align-items: center;

    .btn-acoes-itens {
      flex: 1;
    }
  }
}
</style>
